import { render, staticRenderFns } from "./SimpleHero.vue?vue&type=template&id=2b5624dd&scoped=true&"
import script from "./SimpleHero.vue?vue&type=script&lang=js&"
export * from "./SimpleHero.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHero.vue?vue&type=style&index=0&id=2b5624dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5624dd",
  null
  
)

export default component.exports